"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Grid = void 0;
var ag_grid_react_1 = require("ag-grid-react");
var React = require("react");
var Renderers_1 = require("../../Renderers");
require("ag-grid-community/dist/styles/ag-grid.css");
require("ag-grid-community/dist/styles/ag-theme-material.css");
require("./ag-grid-overrides.css");
// Serves as the base for other grid based components
var Grid = function (props) {
    var _a = React.useState(), gridApi = _a[0], setGridApi = _a[1];
    var _b = React.useState({ columnState: undefined, sortState: undefined }), gridState = _b[0], setGridState = _b[1];
    var constructColData = function () {
        return props.columnDefs.map(function (col) {
            var IsClickable = col.IsClickable, CellEditorMaxLength = col.CellEditorMaxLength, CellEditorValueRequired = col.CellEditorValueRequired, column = __rest(col, ["IsClickable", "CellEditorMaxLength", "CellEditorValueRequired"]);
            if (col.IsClickable) {
                column.cellRendererFramework = Renderers_1.ClickableCell;
            }
            if (col.editable) {
                column.cellRendererFramework = Renderers_1.EditableCell;
                column.cellEditorFramework = Renderers_1.CellEditor;
                column.cellEditorParams = {
                    MaxLength: col.CellEditorMaxLength,
                    ValueRequired: col.CellEditorValueRequired,
                };
            }
            return column;
        });
    };
    var saveColumnState = function (event) {
        if (props.SaveLayout && props.SaveLayoutID !== null && props.SaveLayoutID !== undefined) {
            var columnState = event.columnApi.getColumnState();
            setGridState({ columnState: columnState, sortState: gridState.sortState });
            var stateString = JSON.stringify({ columnState: columnState, sortState: gridState.sortState });
            localStorage.setItem(props.SaveLayoutID, stateString);
        }
        if (props.OnGridLayoutChange) {
            props.OnGridLayoutChange(event);
        }
    };
    var saveColumnSortState = function () {
        var sortState = gridApi.getSortModel();
        setGridState({ sortState: sortState, columnState: gridState.columnState });
        var stateString = JSON.stringify({ columnState: gridState.columnState, sortState: sortState });
        localStorage.setItem(props.SaveLayoutID, stateString);
    };
    var loadColumnState = function (event) {
        if (props.SaveLayout && props.SaveLayoutID !== null && props.SaveLayoutID !== undefined) {
            var stateJson = localStorage.getItem(props.SaveLayoutID);
            if (stateJson !== null && stateJson !== undefined) {
                var state = JSON.parse(stateJson);
                var columnState = state.columnState;
                var sortState = state.sortState;
                if (columnState || sortState) {
                    if (columnState) {
                        event.columnApi.setColumnState(columnState);
                    }
                    if (sortState) {
                        event.api.setSortModel(sortState);
                    }
                }
                else {
                    // If the state has been saved prior to the patch to add sort state then we need to check and use it.
                    // On next save it will start using ISaveState.
                    var deprecatedColumnState = JSON.parse(stateJson);
                    event.columnApi.setColumnState(deprecatedColumnState);
                }
            }
        }
    };
    var handleGridReady = function (event) {
        if (!gridApi) {
            setGridApi(event.api);
        }
        loadColumnState(event);
        if (props.onGridReady !== undefined && props.onGridReady !== null) {
            props.onGridReady(event);
        }
    };
    return (React.createElement("div", { className: "sr-overrides ag-theme-material", style: { height: "100%" } },
        React.createElement(ag_grid_react_1.AgGridReact, __assign({ rowHeight: 40, headerHeight: 32 }, props, { columnDefs: constructColData(), onColumnMoved: saveColumnState, onColumnPinned: saveColumnState, onColumnResized: saveColumnState, onSortChanged: saveColumnSortState, onGridReady: function (e) { return handleGridReady(e); }, stopEditingWhenGridLosesFocus: true, deltaRowDataMode: props.deltaRowDataMode, getRowNodeId: props.getRowNodeId, immutableData: props.immutableData }))));
};
exports.Grid = Grid;
